import { createTheme, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import DashboardInsights from "../dashboard/DashboardInsights";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import MoodTracker from "../../mui/DateCalendar";
import { useHistory } from "react-router-dom";
import KidInterests from "../../mui/KidInterests";
import Lock from '../../../assets/images/Lock.svg';
import PartnerHeader from "./PartnerHeader";
import { HiOutlineChevronLeft } from "@react-icons/all-files/hi/HiOutlineChevronLeft";
import { CAPTAIN_NOTES, SCHOOL_KIDS_ROUTE } from "../../../constants/routes.constants";
import Avatar from "../../common/Avatar";
import MyBadge from "../../common/MyBadge";
import { NORMAL_TYPE } from "../../../constants/avatarType.constants";
import Challenges from '../../../assets/images/flag-Challenges.svg';
import Creations from '../../../assets/images/star-Creations.svg';
import binkyIcon from '../../../assets/images/icon-binky-selected.svg';
import { myRoomViewModel } from "../my_room/my.room.viewmodel";
import RoundButton from "../../common/RoundButton";
import { useAuth } from "../../auth/Auth";
import KidInsightsActionButtons from "./KidInsightsActionButtons";
import { isPayByCamp } from "../../../utils/utils";
import "./campkids.css"
const theme = createTheme({
    palette: {
        background: {
            paper: '#fff',
        },
    },
});

const CampInsights = () => {
    const history = useHistory();
    const username = history?.location?.state?.dependent
    const [showDetailedInsights, setShowDetailedInsights] = useState(false);
    const [dependent, setDependent] = useState({});
    const [loading, setLoading] = useState(true);
    const { school } = useAuth();

    const handleGobackClick = () => {
        history.push(SCHOOL_KIDS_ROUTE);
    }

    const getUserData = () => {
        setLoading(true);
        myRoomViewModel.getDependentUserByName(username)
            .then((res) => {
                setDependent(res.data)
                setLoading(false);
            }).catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getUserData();
    }, [username])

    const handleOpenNotes = () => {
        history.push({
            pathname: CAPTAIN_NOTES,
            state: {
                kid: JSON.stringify(dependent)
            }
        })
    }

    return (
        <div className='treehouse-details partner-wrapper-main'>
            <PartnerHeader />
            <div className='treehouse-back new-payment-plan-back-btn' role="button" onClick={handleGobackClick}>
                <span id='new-back-btn' style={{ top: "10%" }} className="back-btn"><HiOutlineChevronLeft /></span>
            </div>
            {loading ?
                <Spinner
                    key={0}
                    className="home-feed-spinner"
                    animation="border"
                    variant="info"
                />
                :
                <Container className="setting-container setting-wrap" fluid="md">
                    <div className="treehouse-details-header" style={{ paddingTop: "20px", justifyContent: "end" }}>
                        <div className='grade-dropdown'>
                            <div className="filter-container view-note-button-sm">
                                <div className="filter-tag" >
                                    {school?.user_type === 'school' || school?.user_type === "school_teacher" ?
                                        <RoundButton
                                            type="button"
                                            label="View Notes"
                                            className="transparent-button d-sm-block notes-top-btn"
                                            onClick={handleOpenNotes}
                                        />
                                        : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Row className="middle-section guardian-row-box">
                        <Row className="kid-box vertical-height activated insights-dashboard">
                            <Col className="avatar-wrapper ">
                                <Avatar
                                    type={NORMAL_TYPE}
                                    key={dependent?.username}
                                    userProfileUrl={dependent?.profile?.picture_url}
                                    userName={dependent?.username}
                                    firstName={dependent?.first_name}
                                    lastName={dependent?.last_name}
                                    taletreeFriend={dependent?.profile?.taletree_friend}
                                    subscription={dependent?.subscriptions}
                                    activated={dependent?.profile?.is_activated}
                                    id={dependent?.id}
                                    size={120}
                                    profile={dependent?.profile}
                                    school_details={dependent?.school_details}
                                    isInsights={true}
                                />
                                <Row className="badge-wrapper kid-dashboard-manage">
                                    <MyBadge
                                        icon={Creations}
                                        className='first-badge'
                                        count={dependent?.dependent_creation_count}
                                        title={"Creations"}
                                        isEmeralites={!dependent?.subscriptions && dependent?.is_verified && dependent?.profile?.one_time_plan === "Emeralites" ? true : false}
                                    />
                                    <MyBadge
                                        icon={Challenges}
                                        count={dependent?.dependent_challenge_count}
                                        title={"Challenges"}
                                        isEmeralites={!dependent?.subscriptions && dependent?.is_verified && dependent?.profile?.one_time_plan === "Emeralites" ? true : false}
                                    />
                                    <MyBadge
                                        icon={binkyIcon}
                                        count={dependent?.binky_count}
                                        title={"Binkies"}
                                    />
                                </Row>
                            </Col>
                            {school?.user_type === "school" || school?.user_type === "school_teacher" ?
                                <Col className="command-wrapper">
                                    <KidInsightsActionButtons dependent={dependent} />
                                </Col>
                                : null
                            }
                            <Row className="myroom-info-wrapper slider-cards">
                                <Col
                                    className="myroom-collapse insights-soon most-complimented-creation mood-creation" style={{ padding: '0px' }}>
                                    <ThemeProvider theme={theme}>
                                        <KidInterests dependent={dependent} showDetailedInsights={showDetailedInsights} setShowDetailedInsights={setShowDetailedInsights} />
                                    </ThemeProvider>
                                </Col>
                            </Row>
                            <ThemeProvider theme={theme}>
                                <DashboardInsights selectedDependent={dependent} showDetailedInsights={showDetailedInsights} />
                                <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress1">
                                    <Col
                                        className="myroom-collapse insights-soon most-complimented-creation mood-creation">
                                        <MoodTracker type='Comment' cardClass={"short_second_card"} dependent={dependent} />
                                    </Col>
                                </Row>
                            </ThemeProvider>
                        </Row>
                    </Row>
                </Container>
            }
        </div>
    )
}

export default CampInsights;